// ── CONTENT: Activities, Events, Gallery, Blog ───────────────────────────────
const { Ico: I3, Photo: P3, Pic: Pic3, Btn: B3, Eyebrow: E3, Reveal: R3, InteriorHero: IH3 } = window.BCKit;

// ── ACTIVITIES ───────────────────────────────────────────────────────────────
const Activities = ({ go }) => {
  const [data] = window.BCStore.useStore();
  const a = data.pages.activities;
  const phone = data.contact.phone;
  return (
  <main>
    <IH3 eyebrow={a.hero.eyebrow} title={a.hero.title} sub={a.hero.sub} stats={a.hero.stats} photo={a.hero.photo} />
    <section className="section" style={{ display: "flex", flexDirection: "column", gap: 64 }}>
      <div className="wrap" style={{ display: "flex", flexDirection: "column", gap: 64 }}>
        {a.items.map((it, i) => {
          const idx = String(i + 1).padStart(2, "0");
          const side = i % 2 === 0 ? "left" : "right";
          const img = <P3 tone={it.tone} src={it.src} label={it.title} h={280} r={18} />;
          const txt = (
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                <span className="serif" style={{ fontSize: 15, fontWeight: 700, color: "var(--amber)" }}>{idx}</span>
                <span style={{ height: 1, width: 40, background: "var(--rule-2)" }} />
              </div>
              <h3 className="display" style={{ fontSize: "clamp(26px,3vw,34px)" }}>{it.title}</h3>
              <p className="lede" style={{ marginTop: 12, fontSize: 16.5 }}>{it.desc}</p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 9, marginTop: 18 }}>
                {(it.tags || []).map(x => <span key={x} className="chip chip--static">{x}</span>)}
              </div>
            </div>
          );
          return (
            <R3 key={it.id}>
              <div className="grid2" style={{ alignItems: "center", gridTemplateColumns: side === "left" ? "1.05fr 1fr" : "1fr 1.05fr" }}>
                {side === "left" ? <>{img}{txt}</> : <>{txt}{img}</>}
              </div>
            </R3>
          );
        })}
      </div>
    </section>
    <section style={{ background: "var(--green-deep)", color: "#fff" }}>
      <div className="wrap section" style={{ textAlign: "center" }}>
        <R3>
          <h2 className="display" style={{ fontSize: "clamp(28px,4vw,42px)", color: "#fff" }}>{a.cta.title}</h2>
          <p style={{ color: "rgba(255,255,255,.7)", marginTop: 12, fontSize: 16 }}>{a.cta.sub}</p>
          <div style={{ marginTop: 24 }}><B3 kind="amber" size="lg" icon={<I3.phone />} {...window.BCStore.resolveCtaProps(a.cta.primaryLink, { data, go }, { action: "phone", value: "" })}>Call the office</B3></div>
        </R3>
      </div>
    </section>
  </main>
  );
};

// ── EVENTS (accordion) ───────────────────────────────────────────────────────
const Events = ({ go }) => {
  const [data] = window.BCStore.useStore();
  const months = data.events;
  const hero = data.pages.events.hero;
  const phone = data.contact.phone;
  // Open on the current month when it's in the season calendar; otherwise the
  // first month (pre/post-season visitors are planning for the season opener).
  const [open, setOpen] = React.useState(() => {
    const now = new Date().toLocaleString("en-US", { month: "long" }).toLowerCase();
    const idx = months.findIndex(x => (x.m || "").trim().toLowerCase() === now);
    return idx >= 0 ? idx : 0;
  });
  const [filter, setFilter] = React.useState("All");
  const tabs = ["All", ...months.map(m => m.m.slice(0, 3))];
  const visible = months.filter(x => filter === "All" || x.m.startsWith(filter));
  return (
    <main>
      <IH3 eyebrow={hero.eyebrow} title={hero.title} sub={hero.sub} photo={hero.photo} />
      <section className="section">
        <div className="wrap">
          <R3>
            <div style={{ display: "flex", gap: 9, flexWrap: "wrap", marginBottom: 30 }}>
              {tabs.map(t => (
                <span key={t} className={`chip chip--ink ${filter === t ? "chip--on" : ""}`} onClick={() => { setFilter(t); if(t !== "All") { const idx = months.findIndex(x => x.m.startsWith(t)); if(idx >= 0) setOpen(idx); } }}>{t}</span>
              ))}
            </div>
          </R3>
          {visible.map((mo) => {
            const realIdx = months.indexOf(mo);
            const isOpen = open === realIdx;
            const weeks = mo.weeks.filter(w => w.on !== false);
            return (
              <R3 key={mo.m}>
                <div className="acc">
                  <div className={`acc__head ${isOpen ? "acc__head--on" : ""}`} onClick={() => setOpen(isOpen ? -1 : realIdx)}>
                    <h3 className="serif" style={{ fontSize: 23, fontWeight: 700, width: 130, flexShrink: 0 }}>{mo.m}</h3>
                    <span style={{ color: "var(--muted)", fontSize: 14.5, flex: 1 }}>{mo.sum}</span>
                    {mo.badge && <span className="chip" style={{ background: "var(--amber)", borderColor: "var(--amber)", color: "#fff", fontSize: 11.5, fontWeight: 600 }}>★ {mo.badge}</span>}
                    <span className="acc__plus">{isOpen ? "−" : "+"}</span>
                  </div>
                  <div className={`acc__body ${isOpen ? "acc__body--on" : ""}`}>
                    <div className="acc__inner">
                      <div style={{ padding: "4px 24px 24px", borderTop: "1px solid var(--rule)" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))", gap: 12, marginTop: 18 }}>
                          {weeks.map((w, i) => (
                            <div key={w.id} style={{ padding: "16px 18px", background: "var(--paper)", borderRadius: 12, border: "1px solid var(--rule)" }}>
                              <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase", color: "var(--green)" }}>Week {i + 1}</div>
                              <div className="serif" style={{ fontSize: 17, fontWeight: 700, marginTop: 5 }}>{w.title}</div>
                              <div style={{ fontSize: 12.5, color: "var(--muted)", marginTop: 4 }}>Fri – Sun · all weekend</div>
                              {w.badge && <span className="chip" style={{ marginTop: 9, background: "var(--amber-soft)", borderColor: "transparent", color: "var(--amber)", fontSize: 11, fontWeight: 600 }}>★ {w.badge}</span>}
                              {(w.bullets || []).length > 0 && (
                                <ul style={{ listStyle: "none", margin: "10px 0 0", padding: 0, display: "grid", gap: 5 }}>
                                  {(w.bullets || []).map((b, j) => (
                                    <li key={j} style={{ display: "flex", gap: 7, fontSize: 12.5, color: "var(--muted)", lineHeight: 1.4 }}>
                                      <span style={{ color: "var(--green)", flexShrink: 0, marginTop: 1 }}>•</span>
                                      <span>{b}</span>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ))}
                          {weeks.length === 0 && <div style={{ color: "var(--muted)", fontSize: 14, marginTop: 18 }}>No weekends scheduled yet — call the office for the latest.</div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </R3>
            );
          })}
          <R3>
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <h3 className="display" style={{ fontSize: 26 }}>Want a full line-up?</h3>
              <div style={{ marginTop: 18 }}><B3 kind="primary" icon={<I3.phone />} {...window.BCStore.resolveCtaProps((data.contactCtas || {}).eventsCallLink, { data, go }, { action: "phone", value: "" })}>Call {phone}</B3></div>
            </div>
          </R3>
        </div>
      </section>
    </main>
  );
};

// ── RULES & REGULATIONS ──────────────────────────────────────────────────────
// Fully admin-editable (Pages → Rules & Regulations): hero, every section and
// rule line, and the closing CTA all flow from pages.rules in the store.
const Rules = ({ go }) => {
  const [data] = window.BCStore.useStore();
  const r = data.pages.rules || { hero: {}, sections: [], cta: {} };
  const sections = (r.sections || []).filter(s => (s.items || []).length > 0 || (s.title || "").trim());
  return (
    <main>
      <IH3 eyebrow={r.hero.eyebrow} title={r.hero.title} sub={r.hero.sub} photo={r.hero.photo} />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 820 }}>
          {sections.map((s, i) => (
            <R3 key={s.id}>
              <div style={{ padding: "28px 0", borderTop: i === 0 ? "none" : "1px solid var(--rule)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                  <span className="serif" style={{ fontSize: 15, fontWeight: 700, color: "var(--amber)" }}>{String(i + 1).padStart(2, "0")}</span>
                  <span style={{ height: 1, width: 40, background: "var(--rule-2)" }} />
                  <h2 className="display" style={{ fontSize: "clamp(22px,2.6vw,28px)" }}>{s.title}</h2>
                </div>
                <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 10 }}>
                  {(s.items || []).map((it, j) => (
                    <li key={j} style={{ display: "flex", gap: 11, alignItems: "flex-start", fontSize: 16, color: "var(--ink)", lineHeight: 1.65 }}>
                      <I3.check style={{ width: 16, height: 16, color: "var(--green)", flexShrink: 0, marginTop: 5 }} />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </R3>
          ))}
          {sections.length === 0 && (
            <div style={{ color: "var(--muted)", fontSize: 15, padding: "40px 0" }}>Rules are being updated — call the office with any questions.</div>
          )}
        </div>
      </section>
      <section style={{ background: "var(--green-deep)", color: "#fff" }}>
        <div className="wrap section" style={{ textAlign: "center" }}>
          <R3>
            <h2 className="display" style={{ fontSize: "clamp(28px,4vw,42px)", color: "#fff" }}>{r.cta.title}</h2>
            <p style={{ color: "rgba(255,255,255,.7)", marginTop: 12, fontSize: 16 }}>{r.cta.sub}</p>
            <div style={{ marginTop: 24 }}><B3 kind="amber" size="lg" icon={<I3.phone />} {...window.BCStore.resolveCtaProps(r.cta.primaryLink, { data, go }, { action: "phone", value: "" })}>Call the office</B3></div>
          </R3>
        </div>
      </section>
    </main>
  );
};

// ── GALLERY (lightbox) ───────────────────────────────────────────────────────
const Gallery = () => {
  const [data] = window.BCStore.useStore();
  const photos = data.photos;
  const hero = data.pages.gallery.hero;
  const cats = ["All","Events","Activities","People","Pool","Resort"];
  const [cat, setCat] = React.useState("All");
  const [lb, setLb] = React.useState(-1);
  const list = photos.filter(p => cat === "All" || p.cat === cat);

  React.useEffect(() => {
    if (lb < 0) return;
    const onKey = (e) => {
      if (e.key === "Escape") setLb(-1);
      if (e.key === "ArrowRight") setLb(v => (v + 1) % list.length);
      if (e.key === "ArrowLeft") setLb(v => (v - 1 + list.length) % list.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lb, list.length]);

  const cur = lb >= 0 ? list[lb] : null;
  return (
    <main>
      <IH3 eyebrow={hero.eyebrow} title={hero.title} sub={hero.sub} photo={hero.photo} />
      <div style={{ position: "sticky", top: 74, zIndex: 30, background: "var(--white)", borderBottom: "1px solid var(--rule)" }}>
        <div className="wrap" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 28px", flexWrap: "wrap", gap: 12 }}>
          <div style={{ display: "flex", gap: 9, flexWrap: "wrap" }}>
            {cats.map(c => <span key={c} className={`chip ${cat === c ? "chip--on" : ""}`} onClick={() => setCat(c)}>{c}{c === "All" ? ` (${photos.length})` : ""}</span>)}
          </div>
          <span style={{ fontSize: 13, color: "var(--muted)" }}>Showing {list.length} · newest first</span>
        </div>
      </div>
      <section className="section--tight">
        <div className="wrap">
          {list.length === 0
            ? <div style={{ color: "var(--muted)", fontSize: 15, padding: "40px 0" }}>No photos in this category yet.</div>
            : <div className="masonry">
                {list.map((p, i) => (
                  p.src
                    ? <div key={p.id} onClick={() => setLb(i)} className="gcard card--hover" style={{ cursor: "pointer" }}>
                        {/* masonry is 3 cols, 2 under 880px, 1 under 560px */}
                        <Pic3 className="gcard__img" src={p.src} sizes="(max-width:560px) 92vw, (max-width:880px) 44vw, 30vw" />
                      </div>
                    : <div key={p.id} onClick={() => setLb(i)} style={{ cursor: "pointer" }}>
                        <P3 tone={p.tone} h={p.h} r={12} className="card--hover" />
                      </div>
                ))}
              </div>}
        </div>
      </section>

      <div className={`lb ${lb >= 0 ? "lb--open" : ""}`} onClick={() => setLb(-1)}>
        {cur && (
          <>
            <span className="lb__close" onClick={(e) => { e.stopPropagation(); setLb(-1); }}>✕</span>
            <span className="lb__arrow" style={{ left: 30 }} onClick={(e) => { e.stopPropagation(); setLb((lb - 1 + list.length) % list.length); }}>‹</span>
            {cur.src
              ? <img className="lb__img" src={cur.src} alt="" onClick={(e) => e.stopPropagation()} />
              : <P3 tone={cur.tone} h="min(70vh,560px)" r={14} style={{ width: "min(880px,86vw)", boxShadow: "0 30px 80px rgba(0,0,0,.5)" }} onClick={(e) => e.stopPropagation()} />}
            <span className="lb__arrow" style={{ right: 30 }} onClick={(e) => { e.stopPropagation(); setLb((lb + 1) % list.length); }}>›</span>
            <div className="lb__cap" onClick={(e) => e.stopPropagation()}>{lb + 1} of {list.length} — use ← → keys</div>
          </>
        )}
      </div>
    </main>
  );
};

// ── BLOG ─────────────────────────────────────────────────────────────────────
// A body line of the form [photo:/uploads/x.webp] or [photo:/uploads/x.webp|caption]
// renders as an inline figure; every other non-empty line is a paragraph. The
// admin's "Insert photo" button writes these tokens — never hand-typed.
const PHOTO_TOKEN = /^\[photo:\s*([^\]|]+?)\s*(?:\|\s*([^\]]*?)\s*)?\]$/i;
const renderPostBody = (body) => String(body || "").split("\n").map((line, i) => {
  const t = line.trim();
  if (!t) return null;
  const m = PHOTO_TOKEN.exec(t);
  if (m && /^(\/|https?:\/\/)/.test(m[1])) return (
    <figure key={i} style={{ margin: "26px 0" }}>
      <Pic3 src={m[1]} alt={m[2] || ""} sizes="(max-width:880px) 92vw, 700px"
        style={{ width: "100%", height: "auto", borderRadius: 14, display: "block" }} />
      {m[2] ? <figcaption style={{ fontSize: 13.5, color: "var(--muted)", marginTop: 8, textAlign: "center" }}>{m[2]}</figcaption> : null}
    </figure>
  );
  return <p key={i} style={{ marginBottom: 18 }}>{t}</p>;
});

// Left-click navigates in-app; modified/middle clicks keep browser behavior.
const postNavClick = (go, id) => (e) => {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  go(id);
};

const Blog = ({ go, sub }) => {
  const [data] = window.BCStore.useStore();
  const { findPost, postSlug, idToPath } = window.BCStore;
  const phone = data.contact.phone;
  const hero = data.pages.blog.hero;
  const cats = ["All","Camping Tips","Resort News","Events","Activities","Seasonal"];
  const [cat, setCat] = React.useState("All");
  const published = data.blog.filter(p => p.status === "published");
  // Each post is its own URL (/blog/<slug>) — the router passes the slug as `sub`.
  const current = sub ? findPost(published, sub) : null;
  const list = published.filter(p => cat === "All" || p.cat === cat);

  const backLink = (
    <a href="/blog" onClick={postNavClick(go, "blog")} style={{ display: "inline-flex", alignItems: "center", gap: 7, color: "var(--green)", fontWeight: 600, fontSize: 14.5, cursor: "pointer", marginBottom: 24, textDecoration: "none" }}>
      <I3.arrow style={{ width: 16, height: 16, transform: "rotate(180deg)" }} /> Back to the journal
    </a>
  );

  // Single-post page — reached by URL; all content from the store.
  if (current) {
    return (
      <main>
        <IH3 eyebrow={current.cat} title={current.title} sub={`${current.date}${current.readMins ? ` · ${current.readMins} min read` : ""}`} photo={current.src} />
        <section className="section">
          <div className="wrap" style={{ maxWidth: 760 }}>
            <R3>
              {backLink}
              <div className="lede" style={{ fontSize: 18, color: "var(--ink)", lineHeight: 1.8 }}>
                {renderPostBody(current.body || current.excerpt)}
              </div>
            </R3>
          </div>
        </section>
      </main>
    );
  }

  // Slug in the URL but no matching published post (e.g. unpublished mid-session
  // during soft-nav — direct loads 404 at the server before reaching here).
  if (sub) {
    return (
      <main>
        <IH3 eyebrow="Journal" title="That post isn't here anymore." sub="It may have been unpublished or moved." photo={hero.photo} />
        <section className="section">
          <div className="wrap" style={{ maxWidth: 760 }}><R3>{backLink}</R3></div>
        </section>
      </main>
    );
  }

  return (
    <main>
      <IH3 eyebrow={hero.eyebrow} title={hero.title} sub={hero.sub} photo={hero.photo} />
      <section className="section">
        <div className="wrap">
          <R3>
            <div style={{ display: "flex", gap: 9, flexWrap: "wrap", marginBottom: 30 }}>
              {cats.map(c => <span key={c} className={`chip chip--ink ${cat === c ? "chip--on" : ""}`} onClick={() => setCat(c)}>{c}</span>)}
            </div>
          </R3>
          {list.length > 0 ? (
            <div className="grid3">
              {list.map((p, i) => (
                <R3 delay={i * 90} key={p.id}>
                  <a className="card card--hover" href={idToPath("blog/" + postSlug(p))} onClick={postNavClick(go, "blog/" + postSlug(p))} style={{ cursor: "pointer", height: "100%", display: "block", color: "inherit", textDecoration: "none" }}>
                    <P3 tone={p.tone || "meadow"} src={p.src} label={p.title} h={180} />
                    <div style={{ padding: "20px 22px 24px" }}>
                      <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase", color: "var(--green)" }}>{p.cat}</span>
                      <h3 className="serif" style={{ fontSize: 21, fontWeight: 700, marginTop: 8, lineHeight: 1.2 }}>{p.title}</h3>
                      <p style={{ color: "var(--muted)", fontSize: 14, marginTop: 8, lineHeight: 1.6 }}>{p.excerpt}</p>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
                        <span style={{ fontSize: 12, color: "var(--muted)" }}>{p.date}{p.readMins ? ` · ${p.readMins} min` : ""}</span>
                        <span style={{ color: "var(--green)", fontWeight: 600, fontSize: 14, display: "flex", gap: 6, alignItems: "center" }}>Read <I3.arrow style={{ width: 15, height: 15 }} /></span>
                      </div>
                    </div>
                  </a>
                </R3>
              ))}
            </div>
          ) : (
            <div className="grid3">
              {[0,1,2].map(i => (
                <R3 delay={i * 90} key={i}>
                  <div style={{ border: "2px dashed var(--rule-2)", borderRadius: 18, minHeight: 320, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: 28, height: "100%" }}>
                    <div className="serif" style={{ fontSize: 52, fontWeight: 700, color: "var(--rule-2)" }}>?</div>
                    <div style={{ color: "var(--muted)", marginTop: 10, fontSize: 14 }}>Post coming soon</div>
                  </div>
                </R3>
              ))}
            </div>
          )}
          <R3>
            <div style={{ marginTop: 32, padding: "56px 40px", background: "var(--paper-2)", borderRadius: 20, textAlign: "center" }}>
              <h2 className="display" style={{ fontSize: "clamp(28px,3.4vw,36px)" }}>{list.length > 0 ? "More on the way." : "More posts coming soon."}</h2>
              <p style={{ color: "var(--muted)", maxWidth: 420, margin: "12px auto 0", fontSize: 16, lineHeight: 1.6 }}>
                We're working on it. In the meantime, give us a ring for anything you'd want to read about.
              </p>
              <div style={{ marginTop: 22 }}><B3 kind="primary" icon={<I3.phone />} {...window.BCStore.resolveCtaProps((data.contactCtas || {}).blogCallLink, { data, go }, { action: "phone", value: "" })}>Call {phone}</B3></div>
            </div>
          </R3>
        </div>
      </section>
    </main>
  );
};

window.BCContent = { Activities, Events, Rules, Gallery, Blog };
